/**
 * Creates a Base64-encoded ASCII string from a binary string
 *
 * @param {string} str
 * @returns {string}
 */
export const universalBtoa = str => {
  try {
    return btoa(str);
  } catch (err) {
    return Buffer.from(str).toString('base64');
  }
};